import avatar5 from '../../../../assets/images/xs/avatar5.jpg';
import avatar2 from '../../../../assets/images/xs/avatar2.jpg';
import avatar1 from '../../../../assets/images/xs/avatar1.jpg';
import avatar3 from '../../../../assets/images/xs/avatar3.jpg';

import img1 from '../../../../assets/images/gallery/1.jpg';
import img2 from '../../../../assets/images/gallery/2.jpg';
import img3 from '../../../../assets/images/gallery/3.jpg';
import img4 from '../../../../assets/images/gallery/4.jpg';
import img5 from '../../../../assets/images/gallery/5.jpg';
import img6 from '../../../../assets/images/gallery/6.jpg';
import img7 from '../../../../assets/images/gallery/7.jpg';
import img8 from '../../../../assets/images/gallery/8.jpg';
import img9 from '../../../../assets/images/gallery/9.jpg';


export const TrendingData = [
    {
        no: '01',
        image: avatar5,
        name: 'Michelle Glover',
        title: 'Unleashing the Power of ChatGPT',
        date: 'Feb 20',
        read_min: '16 min read',
    },
    {
        no: '02',
        image: avatar2,
        name: 'Kevin Gill',
        title: 'Designing for the Web',
        date: 'Feb 20',
        read_min: '15 min read',
    },
    {
        no: '03',
        image: avatar1,
        name: 'Jony Doe',
        title: 'Building Dynamic User Interfaces with Vue.js',
        date: 'Feb 20',
        read_min: '10 min read',
    },
    {
        no: '04',
        image: avatar3,
        name: 'Robert Mark',
        title: 'Mastering Backend Development with Node.js',
        date: 'Feb 20',
        read_min: '9 min read',
    },
    {
        no: '05',
        image: avatar3,
        name: 'Robert Mark',
        title: 'Creating Cross-Platform Mobile Apps with Flutter',
        date: 'Feb 20',
        read_min: '11 min read',
    },
    {
        no: '06',
        image: avatar1,
        name: 'Jony Doe',
        title: 'Digital Transformation',
        date: 'Feb 20',
        read_min: '15 min read',
    }
]

export const ArticleData = [
    {
        text_color: 'theme-text-color6',
        title: 'Why Time Management is Essential for Success',
        date: 'Feb 20, 2023',
        comment: '1 comment',
        text: "In today's fast-paced world, time management has become more important than ever before. Effective time management can make the difference between success and failure in any aspect of life, whether it's personal or professional."
    },
    {
        text_color: 'theme-text-color2',
        title: 'ChatGPT: The Future of Conversational AI',
        date: 'Feb 19, 2023',
        comment: '18 comment',
        text: "It is a cutting-edge technology that is designed to mimic human conversation and provide natural language processing capabilities. In this blog, we'll explore the future of conversational AI with ChatGPT."
    },
    {
        text_color: 'theme-text-color3',
        title: 'The Importance of Front-end Development in Modern Web Design',
        date: 'Feb 13, 2023',
        comment: '5 comment',
        text: "Front-end development is a critical aspect of modern web design. It is the process of creating the user interface of a website or application, and it plays a crucial role in determining the user experience."
    },
    {
        text_color: 'theme-text-color4',
        title: 'The Top Benefits of Angular for Web Development',
        date: 'Feb 10, 2023',
        comment: '7 comment',
        text: "Angular is a popular JavaScript frabviterk that is widely used for web development. It offers a variety of features and benefits that make it a top choice for web developers. In this blog, we'll explore the top benefits of Angular for web development."
    },
    {
        text_color: 'theme-text-color4',
        title: 'The Science Behind Optimism and How It Can Transform Your Life',
        date: 'Feb 10, 2023',
        comment: '7 comment',
        text: "We'll delve into the research behind optimism and its ability to reduce stress, improve relationships, and enhance overall well-being."
    },
    {
        text_color: 'theme-text-color2',
        title: 'The Future of Digital Ownership and Creativity',
        date: 'Feb 10, 2023',
        comment: '7 comment',
        text: "It will explore the basic concepts of NFTs, including how they work, what makes them unique, and their potential applications across a wide range of industries."
    }
]

export const MattersData = [
    {
        theme_color: 'var(--theme-color1)',
        title: 'AI'
    },
    {
        theme_color: 'var(--theme-color2)',
        title: 'ChatGPT'
    },
    {
        theme_color: 'var(--theme-color3)',
        title: 'Startup'
    },
    {
        theme_color: 'var(--theme-color2)',
        title: 'Leadership'
    },
    {
        theme_color: 'var(--theme-color4)',
        title: 'IOT'
    },
    {
        theme_color: 'var(--theme-color6)',
        title: 'Blockchain'
    },
    {
        theme_color: 'var(--theme-color5)',
        title: 'Dataanalytics'
    }
]

export const InstagramData = [
    {
        gallery: img1
    },
    {
        gallery: img2
    },
    {
        gallery: img3
    },
    {
        gallery: img4
    },
    {
        gallery: img5
    },
    {
        gallery: img6
    },
    {
        gallery: img7
    },
    {
        gallery: img8
    },
    {
        gallery: img9
    }
]